import { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";

export default function ScenarioManager({ inputs, onLoad }) {
  const [scenarios, setScenarios] = useState([]);

  useEffect(() => {
    axios.get("/api/user/scenarios/")
      .then((res) => setScenarios(res.data))
      .catch(console.error);
  }, []);

  const save = () => {
    axios.post("/api/user/scenarios/", { name: `Scenario ${Date.now()}`, inputs })
      .then((res) => setScenarios((s) => [...s, res.data]))
      .catch(console.error);
  };

  const remove = (id) => {
    axios.delete(`/api/user/scenarios/${id}/`)
      .then(() => setScenarios((s) => s.filter((sc) => sc.id !== id)))
      .catch(console.error);
  };

  return (
    <div className="mt-4">
      <h3 className="text-lg font-medium text-textPrimary">Scenarios</h3> {/* Title color */}
      <div className="space-y-2 text-textPrimary"> {/* Default text for scenario list items */}
        {/* Scenarios would be listed here, ensure their text elements also use theme colors if not inheriting */}
      </div>
      <Button className="mt-2" onClick={save}>
        Save Current
      </Button>
    </div>
  );
}
